// PerShareByClassTable — every security class value (F5.4).

import type { PerShareByClass } from '@backsolve/shared-types';
import { usd, usdPrecise, fmtShares } from '../../format/format';

export function PerShareByClassTable({ classes }: { classes: PerShareByClass[] }) {
  if (classes.length === 0) return null;
  return (
    <div className="card">
      <div className="card-title">Per-Share Value by Class</div>
      <p className="result-caption">
        Total allocated value divided by as-converted shares for every class.
        Common&apos;s per-share value equals the pre-DLOM FMV; preferred values
        reflect waterfall seniority and participation terms.
      </p>
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Class</th>
              <th className="numeric">Per-Share Value</th>
              <th className="numeric">Total Value</th>
            </tr>
          </thead>
          <tbody>
            {classes.map((c) => (
              <tr key={c.instrumentId}>
                <td>{c.name}</td>
                <td className="numeric">{usdPrecise(c.perShareValue)}</td>
                <td className="numeric">{usd(c.totalValue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="field-hint mt-2">
        {fmtShares(classes.length)} classes
      </p>
    </div>
  );
}
